import { useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';
import { useUpsertConsumerByIdMutation } from 'generated/graphql';
import toast from 'react-hot-toast';
import { chatChannelType } from './helpers';

export const useChatNewMessage = ({ userId }: { userId: string }) => {
  const url = new URL(window.location.href);
  const consumerId = url.searchParams.get('userId');
  const { client, setActiveChannel } = useChatContext();
  const [upsertConsumerById] = useUpsertConsumerByIdMutation({
    variables: {
      id: consumerId ? Number(consumerId) : 0,
    },
  });

  useEffect(() => {
    if (client && consumerId) {
      const createOneChannel = async () => {
        try {
          await upsertConsumerById();

          const conversation = client.channel(chatChannelType, null, {
            members: [`${userId}`, `${consumerId}`],
          });

          await conversation.create();
          setActiveChannel(conversation, { limit: 0, offset: 1 });
          await conversation.watch();
        } catch (error) {
          toast.error(
            `Could not start conversation with this user id: ${consumerId}`,
          );
          console.warn(error);
        }
      };
      createOneChannel();
    }
  }, [client, consumerId, setActiveChannel, upsertConsumerById, userId]);
};
